@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

:host {
  height: 100%;

  // Styles for CustomerContact -- Default Header
  .ghf-customerContact--default {
    display: flex;
    align-items: center;
    gap: $spacing-8;
    height: 100%;

    .ghf-customerContact-help {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .ghf-customerContact-info {
      display: none;
      flex-direction: column;
    }

    .ciHeader-phoneNumberLink {
      text-decoration: none;
      color: inherit;
    }

    .ghf-customerContact {
      &-icon {
        display: flex;
      }

      &-text {
        font-size: var(--typography-button-small-size, $typography-button-small-size);
        color: var(--color-title,$color-gray-slate-default);
        white-space: nowrap;
      }

      &-helpText {
        font-size: var(--typography-button-small-size, $typography-button-small-size);
        color: var(--color-title,$color-gray-slate-default);
        white-space: nowrap;
      }

      &-storeText {
        font-size: var(--typography-button-medium-size, $typography-button-medium-size);
        margin: 0;
        color: var(--color-subtitle,$color-red-default);
        text-decoration: none;
        white-space: nowrap;
      }
    }
    .ghf-customerContact-helpText,
    .ghf-customerContact-text{
      display: none;
    }
    .ghf-customerContact-info {
      display: flex;
      gap: 2px;
    }
    @media (min-width: 700px) {
      .ghf-customerContact-text{
        display: block;
      }
    }
  }
}
